import {
  groupItemListOptions,
  useAdaptExpandedGroupItemToItemListOption,
} from '@/contexts/item-context-utils';
import { ItemListOption } from '@/contexts/item-context-types';
import { useCallback, useMemo } from 'react';
import { useCatalogGroupItemsStore } from '@/stores/catalog-group-items-store';
import { useItemDisplayOptions } from '@/contexts/new-order-context';

export const useCatalogGroupItems = (
  groupKey: string | null,
): {
  error: boolean;
  items: ItemListOption[];
  loading: boolean;
  retry: () => void;
} => {
  const adaptExpandedGroupItem = useAdaptExpandedGroupItemToItemListOption();
  const itemDisplayOptions = useItemDisplayOptions();
  const entry = useCatalogGroupItemsStore((state) =>
    groupKey ? state.groups[groupKey] : undefined,
  );

  const retry = useCallback(() => {
    if (groupKey) {
      useCatalogGroupItemsStore.getState().requestGroupItems([groupKey]);
    }
  }, [groupKey]);

  const items = useMemo(() => {
    if (entry?.status !== 'loaded') {
      return [];
    }

    const options: ItemListOption[] = [];
    for (const row of entry.entries) {
      if (row.variant_pack_data) {
        options.push(
          adaptExpandedGroupItem(row.variant_pack_data, row.salt_data),
        );
      }
    }

    return groupItemListOptions(options, itemDisplayOptions);
  }, [adaptExpandedGroupItem, entry, itemDisplayOptions]);

  return {
    error: entry?.status === 'error',
    items,
    loading: !entry || entry.status === 'loading',
    retry,
  };
};
